module.exports = __webpack_public_path__ + "img/admin_adv_14.0b143692.png";